import openWindow from '../../util/open_window'
import { bindings } from '@polleverywhere/slideware-bindings'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'

async function slidewareSettings () {
  if (store.getState()[appSlice.name].mode !== 'integration') { return {} }

  try {
    return await bindings.settings()
  } catch (error) {
    console.error(error)
  }

  return {}
}

export default async function profile (state, _, lastPage, pageOptions) {
  const Settings = (await import(/* webpackChunkName: 'settings' */ '../../apps/settings')).default
  const { isMacStatusMenuBarVisible } = await slidewareSettings()
  const { allowRedirects } = store.getState()[appSlice.name].options

  const view = new Settings({
    allowRedirects: allowRedirects,
    settings: state.get('settings'),
    state: state.appStates.settings,
    isMacStatusMenuBarVisible
  })

  view.on('click:url', openWindow)
  view.on('isMacStatusMenuBarVisibleChanged', isMacStatusMenuBarVisible => bindings.configApp({ isMacStatusMenuBarVisible }))

  return view
}
